import { useTranslation } from 'react-i18next';
import { ActionIcon, Indicator, Popover, Tooltip } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconBell } from '@tabler/icons-react';
import { useNotificationList, useUnreadCount } from '@/hooks/useNotifications';
import NotificationPanel from './NotificationPanel';
import touchTarget from '@/components/common/touchTarget.module.css';

// Колокольчик в хедере: бейдж непрочитанных + выпадающая панель уведомлений. История грузится через
// useNotificationList; live-обновления приходят в тот же кэш из realtime/useRealtime (SSE).
export default function NotificationBell() {
  const { t } = useTranslation();
  const [opened, { toggle, open, close }] = useDisclosure(false);
  const query = useNotificationList();
  const unread = useUnreadCount(query.data);

  // Доступное имя кнопки несёт число непрочитанных (бейдж — визуальный дубль для зрячих).
  const bellLabel = unread > 0 ? `${t('app.notifications.label')} (${unread})` : t('app.notifications.label');

  return (
    <Popover
      opened={opened}
      onChange={(next) => (next ? open() : close())}
      position="bottom-end"
      // На узких телефонах панель не должна выходить за край экрана.
      width="min(380px, calc(100vw - 16px))"
      shadow="md"
      radius="md"
      trapFocus
      withArrow
    >
      <Popover.Target>
        <Indicator label={unread > 99 ? '99+' : unread} disabled={unread === 0} color="red.9" size={16} offset={5}>
          <Tooltip label={t('app.notifications.label')} disabled={opened}>
            <ActionIcon
              variant="subtle"
              color="gray"
              className={touchTarget.target}
              aria-label={bellLabel}
              aria-haspopup="dialog"
              aria-expanded={opened}
              onClick={toggle}
            >
              <IconBell size={20} />
            </ActionIcon>
          </Tooltip>
        </Indicator>
      </Popover.Target>

      <Popover.Dropdown p={0}>
        <NotificationPanel query={query} onClose={close} />
      </Popover.Dropdown>
    </Popover>
  );
}
